import React from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../store/auth/selectors'
import { MenuForAuthenticated } from './menu-for-authenticated'
import { MenuForNotAuthenticated } from './menu-for-not-authenticated'
import { useAppHeaderRightMenuStyles } from './app-header-right-menu.styles'

export const AppHeaderRightMenu: React.FC = (): React.ReactElement => {
  const classes = useAppHeaderRightMenuStyles()
  const user = useSelector(selectUser)

  return (
    <div className={classes.root}>
      <>
        {user.userId ? <MenuForAuthenticated /> : <MenuForNotAuthenticated />}
      </>
    </div>
  )
}
